/*Adhoc report*/
if (window.location.pathname.includes("reports/adhoc")) {
    $(window).on("confirm.bs.popover", function(e, popover, confirm){
        const ele = $(popover.element);
        if(confirm && ele.hasClass("update-query")) {
            window.app_methods.update_query();
        } else if(confirm && ele.hasClass("delete-query")) {
            window.app_methods.delete_query(ele.attr('data-id'));
        }
        ele.popover("dispose");
    });



    $(window).on("dataTableInit.limelight", function(e, t) {
        t.on('order.dt search.dt', function () {
            if (window.app_data.query_builder.status.show_count == 'true' || window.app_data.query_builder.status.show_count === true) {
                t.column(0, {search:'applied', order:'applied'}).nodes().each( function (cell, i) {
                    cell.innerHTML = i+1;
                });
            }
        }).draw();
    });
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/reports/adhoc.js